import { faCheckCircle, faPencil, faPlus, faTimesCircle, faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { ActionButton, HeadingItem, QuantityAdjuster } from 'components';
import { TripContext } from 'contexts';
import { FileUploader } from 'devextreme-react';
import { UploadedEvent } from 'devextreme/ui/file_uploader';
import React, { FC, useContext, useState } from 'react';
import { useOrderItemService } from 'services';
import { ReconcileReasonType } from 'services/enums';
import { OrderItem, OrderItemChange, ReconcileReason } from 'services/types';
import { OrderItemChangeImage } from 'services/types';
import { useImageUploadService } from 'services/useImageUploadService';
import { IconOptions } from 'types';
import './add-refusal-card.scss';

type Props = {
    orderItemId: number,
    reconcileReasonId: number,
    onQuantityAdjusted: (quantity: number) => void,
    onClickReturnSticker: () => void
}

export const AddRefusalCard: FC<Props> = ({ orderItemId, reconcileReasonId, onQuantityAdjusted, onClickReturnSticker }) => {
    const { isOrderItemChangeComplete } = useOrderItemService()
    const { addImageToTheTripContext, removeAllUploadedImagesByOrderItemChangeId, removeUploadedImageById, getImgUrl } = useImageUploadService()

    const tripContext = useContext(TripContext)

    const orderItem: OrderItem = tripContext.orderItems.find(oi => oi.id === orderItemId) ?? {} as OrderItem
    const reconcileReason: ReconcileReason = tripContext.reconcileReasons.find(reason => reason.id === reconcileReasonId) ?? {} as ReconcileReason
    const orderItemChanges: OrderItemChange[] = tripContext.orderItemChanges.filter(change => change.orderItemId === orderItem.id)
    const orderItemChange: OrderItemChange = orderItemChanges.find(change => change.orderItemId === orderItem.id && change.reconcileReasonId === reconcileReason.id) ?? {} as OrderItemChange

    const changeQuantity: number = orderItemChange.quantity >= 0 ? orderItemChange.quantity : 0
    const isReconcileComplete = (item: OrderItemChange): IconOptions => isOrderItemChangeComplete(item) ? { icon: faCheckCircle, size: '2x', color: '#76AB21' } : { icon: faTimesCircle, size: '2x', color: '#EB5757' }

    let orderItemChangeQuantity: number = 0
    orderItemChanges.forEach(change => {
        if (change.reconcileReasonId != ReconcileReasonType.OverageKept)
            orderItemChangeQuantity += change.quantity
    })

    const uploadedImages: OrderItemChangeImage[] = tripContext.orderItemChangeImages.filter(x => x.orderItemChangeId == orderItemChange.id)

    const handleQuantityAdjusted = async (quantity: number): Promise<void> => {
        if (quantity === 0) {
            removeAllUploadedImagesByOrderItemChangeId(orderItemChange.id);
        }

        onQuantityAdjusted(quantity)
    }

    const handleRemoveFile = (imageId: number): void => {
        removeUploadedImageById(imageId)
    }

    const adjustedQuantity: number = orderItem.shippedQuantity > orderItem.countedQuantity ? orderItem.shippedQuantity : orderItem.countedQuantity
    const deliveredQuantity: number = adjustedQuantity - orderItemChangeQuantity

    const returnStickerAction: string = isOrderItemChangeComplete(orderItemChange) ? 'Edit' : (orderItemChange.refusalChoiceId ? 'Finish' : 'Add')

    return (
        <div className={'card-material'}>
            <HeadingItem text={reconcileReason.description} rightHandIcon={changeQuantity > 0 ? isReconcileComplete(orderItemChange) : undefined} />
            
            <QuantityAdjuster
                quantity={changeQuantity}
                id={reconcileReason.id}
                maxValue={deliveredQuantity + changeQuantity}
                onQuantityAdjusted={(id, quantity) => handleQuantityAdjusted(quantity)}
                inputDelay={500}
            />
            
            {(reconcileReason.isRefusalReasonRequired == true && changeQuantity > 0) ?
                <div className={'refusal-action-row'}>
                    <FileUploader
                        selectButtonText={'Add Photos'}
                        multiple={true}
                        accept={"image/*"}
                        allowCanceling={true}
                        showFileList={false}
                        labelText={''}
                        uploadFile={(file: File) => {}}
                        onUploaded={(uploadedEvent: UploadedEvent) => {
                            addImageToTheTripContext(uploadedEvent.file, orderItemChange)
                        }} 
                    />
                    <ActionButton
                        icon={orderItemChange.refusalChoiceId ? faPencil : faPlus}
                        iconSize={'1x'}
                        buttonText={`${returnStickerAction} Sticker`}
                        buttonColor={orderItemChange.refusalChoiceId ? '#F2994A' : '#EB5757'}
                        buttonWidth={'125px'}
                        onClick={onClickReturnSticker} 
                    />
                </div>
                :
                (changeQuantity > 0) &&
                    <div className='add-photo-button'>
                        <FileUploader
                            selectButtonText={'Add Photos'}
                            multiple={true}
                            accept={"image/*"}
                            allowCanceling={true}
                            showFileList={false}
                            labelText={''}
                            uploadFile={(file: File) => {}}
                            onUploaded={(uploadedEvent: UploadedEvent) => {
                                addImageToTheTripContext(uploadedEvent.file, orderItemChange)
                            }} 
                        />
                    </div>
            }

       
            {uploadedImages.length > 0 && uploadedImages.map(uploadedImage =>
                <div key={uploadedImage.id} className={'uploaded-image-list'}>
                    <img className={'uploaded-image'} src={uploadedImage.file as string} />
                    <ActionButton
                        icon={faTrashAlt}
                        iconSize={'lg'}
                        buttonColor={'#EB5757'}
                        buttonWidth={'40px'}
                        circular={true}
                        onClick={() => handleRemoveFile(uploadedImage.id)} 
                    />
                </div >
            )}
        </div >
    )
}